// eslint-disable-next-line import/prefer-default-export
export const enrichParamsWithSemanticFlags = (
  params,
  { semanticSearchIncluded, semanticResultName, textQuery, assistantEligible } = {}
) => ({
  ...params,
  ...(semanticSearchIncluded !== undefined && { semanticSearchIncluded }),
  ...(semanticResultName && { semanticResultName }),
  ...(textQuery && { textQuery }),
  ...(assistantEligible !== undefined && { assistantEligible }),
});
